/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchFollowingPressReleaseResponseData,
    SearchFollowingPressReleaseResponseDataFromJSON,
    SearchFollowingPressReleaseResponseDataFromJSONTyped,
    SearchFollowingPressReleaseResponseDataToJSON,
} from './SearchFollowingPressReleaseResponseData';

/**
 * 
 * @export
 * @interface SearchFollowingPressReleaseResponse
 */
export interface SearchFollowingPressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchFollowingPressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchFollowingPressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {SearchFollowingPressReleaseResponseData}
     * @memberof SearchFollowingPressReleaseResponse
     */
    data: SearchFollowingPressReleaseResponseData;
}

export function SearchFollowingPressReleaseResponseFromJSON(json: any): SearchFollowingPressReleaseResponse {
    return SearchFollowingPressReleaseResponseFromJSONTyped(json, false);
}

export function SearchFollowingPressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFollowingPressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchFollowingPressReleaseResponseDataFromJSON(json['data']),
    };
}

export function SearchFollowingPressReleaseResponseToJSON(value?: SearchFollowingPressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchFollowingPressReleaseResponseDataToJSON(value.data),
    };
}

